export default [
  {
    path: '/partner-agreement',
    component: () => import('@views/events/partnerAgreement/List')
  }
]



// WEBPACK FOOTER //
// ./src/routers/frontend.js